(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-reviews"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>document.querySelectorAll('[data-review-strip]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const slides=[...root.querySelectorAll('.mp-review-slide')],button=root.querySelector('[data-review-pause]');if(slides.length<2)return;let index=0,timer=null,paused=matchMedia('(prefers-reduced-motion:reduce)').matches;const show=i=>{index=(i+slides.length)%slides.length;slides.forEach((el,n)=>el.hidden=n!==index);};const stop=()=>{clearInterval(timer);timer=null;};const sync=()=>{stop();if(!paused&&!document.hidden&&!root.matches(':hover')&&!root.contains(document.activeElement))timer=setInterval(()=>show(index+1),6000);button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);button.firstElementChild.textContent=paused?'▶':'Ⅱ';};button.addEventListener('click',()=>{paused=!paused;sync();});root.querySelector('[data-review-prev]').addEventListener('click',()=>{show(index-1);sync();});root.querySelector('[data-review-next]').addEventListener('click',()=>{show(index+1);sync();});root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',sync);root.addEventListener('focusin',stop);root.addEventListener('focusout',()=>setTimeout(sync,0));document.addEventListener('visibilitychange',sync);sync();});init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();
})();
